// extracted by mini-css-extract-plugin
export default {"root":"AppMessages_root__P92tu","text":"AppMessages_text__+oFz4"};